import { useEffect, useState } from "react";
import Select from "react-select";
import Datepicker from "react-tailwindcss-datepicker";
import Paginator from "../../shared/Paginator";
import API from "../../services/api";
import { roles, toLakhs, types } from "../../utils/constants";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import { formatDate } from "../../utils/dateFormat";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import NoImage from "../../assets/images/NoImage.png";
import Button from "react-bootstrap/Button";
import { Modal } from "react-bootstrap";
import { Toast } from "../../shared/Toast";
import ReportBirdview from "../SalesPanel/ReportBirdview";
import { CommentAd, FullImage, Fullvideo, FullVideoOrGif, Gallery, HalfVideo, PromotedGallery, PromotedImage, PromotedVideo, RectangleClassified, WebView } from "../SalesPanel/BirdViewData";

const PrintDataSummary = ({ title = "Summary", open, handleRequestClose, handleClose, payload, getColors }) => {
  const [data, setData] = useState([]);

  const [dateRange, setDateRangeState] = useState(payload?.payload?.dateRange);
  const [adFormats, setAdFormats] = useState([]);
  const [selectedAdFormats, setSelectedAdFormats] = useState([]);
  const [campaigns, setCampaigns] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [loader, setLoader] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [see, setSee] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [reportId, setReportId] = useState(0);
  const [imageUrl, setImageUrl] = useState();

  const page_limit = 10;
  useEffect(() => {
    if (!open) return;
    if(payload?.url?.includes("getW2nAlphaAds")){
       setAdFormats(types)
       return;
    }
    const adFormats = async () => {
      const result = await API({
        url: "/eenenadupagerates/getad_types",
        method: "POST",
        data: { newspaper: "Eenadu" },
      });
      if (result?.status === "SUCCESS") {
        setAdFormats(result.data);
      }
    };

    adFormats();
  }, [open]);
  


  const getData = async () => {
    setLoader(true);
    try {
      const response = await API({
        url: payload?.url,
        method: "POST",
        responseType: "json",
        data: {
          ...payload?.payload,
          dateRange: dateRange,
          ad_formats: selectedAdFormats.map((a) => a.value),
          limit: page_limit,
          page: currentPage,
        },
      });

      if (response?.code === 200) {
        let summaryData = response.data.data;
        let summaryMap = {};
        setTotalPages(Math.ceil((+response.data.total || 0) / page_limit));
        setCampaigns(summaryData);
        summaryData.forEach((item) => {
          const date = formatDate(item.date || item.created_date)
          if (selectedAdFormats.length) {
            if (selectedAdFormats.some((a) => a.value === item.ad_format)) {
              if (!summaryMap[date]) summaryMap[date] = { count: 0, spent: 0, ad_formats: [] };
              summaryMap[date].count++;
              summaryMap[date].spent += (+item.estimated_value || +item.spent);
              summaryMap[date].ad_formats.push((item.ad_format || item.sub_type));
            }
          } else {
            if (!summaryMap[date]) summaryMap[date] = { count: 0, spent: 0, ad_formats: [] };
            summaryMap[date].count++;
            summaryMap[date].spent += (+item.estimated_value || +item.spent);
            summaryMap[date].ad_formats.push((item.ad_format || item.sub_type));
          }
        });
        summaryMap = Object.entries(summaryMap).map(([date, data]) => ({ date, ...data }));
        setData(summaryMap);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
    setLoader(false);
  };
  
  useEffect(() => {
    if (!open) return;
    getData();
  }, [open, dateRange, selectedAdFormats, currentPage]);


  if (!open || !payload) return null;

  const PreviewData = () => {
    return (
      <>
        {campaigns?.length && !loader ? (
          <div className="birdviewWrapper">
            <ul className="birdview">
              {campaigns.map((item, index) => (
                <li key={index}>
                  <div className="theme">
                    {item?.image_url ? <img src={item?.image_url || NoImage} alt="adImage" loading="lazy" decoding="async" /> : <img src={item?.image_url || NoImage} alt="adImage" loading="lazy" decoding="async" />}

                    <div className="blur">{item?.image_url ? <img src={item?.image_url || NoImage} alt="adImage" loading="lazy" decoding="async" /> : <img src={item?.image_url || NoImage} alt="adImage" loading="lazy" decoding="async" />}</div>

                    <div className="publisher">
                      {item?.newspaper_name && <h6 style={getColors(item.newspaper_name)}>{item.newspaper_name}</h6>}

                      {item?.ad_type === "Local" ? <h6 className="local">{item.ad_type}</h6> : item?.ad_type === "National" ? <h6 className="national">{item.ad_type}</h6> : <h6 className="districts">{item.ad_type}</h6>}
                    </div>

                    <p className="estimation">
                      Est Val: <strong>{(+item.estimated_value || +item.spent) || 0}</strong>
                    </p>

                    {item.image_url && (
                      <Button
                        className="previewBtn"
                        variant="neutral"
                        onClick={() => {
                          setImgSrc(item.image_url);
                          setSee(true);
                        }}
                      >
                        Preview
                      </Button>
                    )}
                  </div>
                 {localStorage.getItem('role') === roles.salesperson ?  <button
                    onClick={() => {
                      setReportId(item.id);
                      setImageUrl(item.image_url);
                      setShowReport(true);
                    }}
                    className="border-[1px] !z-10 !border-red-500 bg-white text-xs font-bold text-red-500 px-2 py-1 rounded-md absolute right-2 top-2 flex gap-1 items-center hover:text-white hover:!bg-red-500"
                  >
                    <sl-icon library="lucide" name="alert-triangle"></sl-icon>
                    <span>Report</span>
                  </button> : null}
                  <div className="description">
                    <p>
                      Page {item?.page_no || "-"} : {formatDate(item.date)}
                    </p>

                    <h1>{item.campaign_name || "-"}</h1>
                    <h5>Edition : {item.edition || " "}</h5>
                    <h5>Ad Format : {item.ad_format || " "}</h5>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : !data?.length && !loader ? (
          <NoDataFound colspan="17" />
        ) : (
          <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </>
    );
  };
  const PreviewW2nData = () => {
    return (
      <>
        <div className="d-flex flex-wrap ">
          {campaigns?.length ? (
            <div className="birdviewWrapper m-0">
              <ul className="birdview">
                {campaigns.map((creative, index) => {
                  const commonProps = {
                    creative,
                    spent: creative.spent,
                    language: creative.lang_id,
                    campaign_name: creative.campaign_name,
                    colors: getColors("Way2news"),
                  };

                  const typeMap = {
                    full_image: <FullImage {...commonProps} length={1} />,
                    gallery: <Gallery {...commonProps} />,
                    full_video: <Fullvideo {...commonProps} />,
                    half_video: <HalfVideo {...commonProps} />,
                    promoted_image_story: <PromotedImage {...commonProps} />,
                    promoted_video_story: <PromotedVideo {...commonProps} />,
                    promoted_gallery: <PromotedGallery {...commonProps} />,
                    webviewad: <WebView {...commonProps} />,
                    commentad: <CommentAd {...commonProps} />,
                    fullvideo_or_gif: <FullVideoOrGif {...commonProps} />,
                    rectangle_classified: <RectangleClassified {...commonProps} />,
                  };

                  return <li key={creative.campaign_id || index}>{typeMap[creative.sub_type] || null}</li>;
                })}
              </ul>
            </div>
          ) : (
            <div className="p-4 text-center w-100 text-muted">No creatives found.</div>
          )}
        </div>
      </>
    );
  };
  return (
    <div className="w-full h-full">
      <SlDrawer label={title} open={open} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ "--size": "80vw" }}>
        <div className="flex flex-wrap gap-3 mb-3">
          <div className="w-72">
            <Datepicker
              classNames="form-input"
              value={dateRange}
              primaryColor="cyan"
              showShortcuts={true}
              useRange={true}
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={(e) => setDateRangeState(e)}
            />
          </div>

          <div className="w-64">
            <Select isMulti options={adFormats} value={selectedAdFormats} onChange={setSelectedAdFormats} placeholder="Ad Formats" menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} />
          </div>
        </div>
        <div>
          {loader ? (
            <TableSkelton colspan={4} />
          ) : (
            <table className="bg-white z-50 table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Ad Formats</th>
                  <th title={data?.reduce((acc, item) => acc + (item.count || 0), 0)}>Count ({toLakhs(data?.reduce((acc, item) => acc + (item.count || 0), 0))})</th>
                  <th title={data?.reduce((acc, item) => acc + +item.spent, 0)}>Revenue ({toLakhs(data?.reduce((acc, item) => acc + +item.spent, 0))})</th>
                </tr>
              </thead>
              <tbody>
                {data.length
                  ? data.map((item) => {
                      return (
                        <tr key={`${item.date}`}>
                          <td>{item.date}</td>
                          <td>
                            <div className="flex gap-1 flex-wrap">
                              {" "}
                              {[...new Set(item.ad_formats || [])].map((f, i) => (
                                <span key={i} className="px-2 py-1 bg-gray-200 rounded text-xs">
                                  {" "}
                                  {f}{" "}
                                </span>
                              ))}{" "}
                            </div>
                          </td>
                          <td>{item.count}</td>
                          <td title={item.spent}>{toLakhs(item.spent)}</td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          )}
        </div>
        <div className="sticky top-0 z-50 bg-white border-b py-1">
          <Paginator pageCount={totalPages} forcePage={currentPage} handlePageClick={(e) => setCurrentPage(e.selected)} />
        </div>{" "}
        {payload?.url?.includes("getW2nAlphaAds") ? <PreviewW2nData /> : <PreviewData />}
        <ReportBirdview open={showReport} setOpen={setShowReport} reportId={reportId} image_url={imageUrl} />
        <Modal className="birdview-image-preview" show={see} onHide={() => setSee(false)}>
          <Modal.Header closeButton>Image Preview</Modal.Header>
          <Modal.Body>
            <img src={imgSrc} alt="" />
          </Modal.Body>
        </Modal>
      </SlDrawer>
    </div>
  );
};

export default PrintDataSummary;
